import CruiseDeal1 from '../assets/singapore.avif';
import CruiseDeal2 from '../assets/Vibrant Caribbean _.jpg';
import CruiseDeal3 from '../assets/europe2.jpg' ;
import CruiseDeal4 from '../assets/meddatrian.png';
import CruiseDeal5 from '../assets/CEL_EG_Alaska.jpg';
import CruiseDeal6 from '../assets/italy_europe.jpg';
import CruiseDeal7 from '../assets/silversea_europe.jpg';
import CruiseDeal8 from '../assets/Silversea-alaska.jpg';
import DealLogoRoyal from '../assets/RCI_Brand_Logo_2-Line_Horiz_Navy_RGB.png';
import DealLogoCelebrity from "../assets/CEL_NCC_Logo 1.png";
import DealLogoAzamara from "../assets/azamara.png";
import DealLogoSilver from "../assets/Silversea_Standard logo_rgb (2).png"

const CruiseDealdata = [
    {
      img: CruiseDeal1,
      Destination:  "Picturesque Singapore" ,   //Royal
      Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
      Ship : "Ovation of the Seas Valid till 31st July 2025 ",
      Brand : DealLogoRoyal,
    //   link :"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=13717&DeparturePorts=SIN&sortColumn=departureDate&sortOrder=asc"
      link :{
        USD :"/singapore",
        INR : "/singapore"
    }
},
    {
        img: CruiseDeal2,
        Destination:  "Vibrant Caribbean" ,   //Royal
        Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
        Ship : "Star of the Seas Valid till 31st July 2025 ",
        Brand : DealLogoRoyal,
          link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc"
    }
      

    },
    {
        img: CruiseDeal3,
        Destination:  "Europe" ,   //Royal
        Offer : "Get 60% OFF On Second Guest + Kids Cruise FREE",
        Ship : "Legend of the Seas, Allure of the Seas, Odyssey of the Seas,  Valid till 31st July 2025 ",
        Brand : DealLogoRoyal,
             link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&destinationtype=All&Ship=15330&sortColumn=cruiselinePriority&sortOrder=asc"
    }

    },
    {
        img: CruiseDeal4,
        Destination:  "Europe" ,     // Celebrity
        Offer : "BOGO75 – 75% off the second guest + Additional Savings*",
        Ship : " Valid till 31st July 2025",
         Brand : DealLogoCelebrity,
                  link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=2&destinations=75&durations=&destinationtype=All",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=2&destinations=75&durations=&destinationtype=All"
    }

    },
    {
        img: CruiseDeal5,
        Destination:  "Alaska" ,     // Celebrity
        Offer : "BOGO75 – 75% off the second guest + Additional Savings*",
        Ship : " Valid till 31st July 2025 ",
         Brand : DealLogoCelebrity,
                  link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=2&destinations=1&durations=&destinationtype=All",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=2&destinations=1&durations=&destinationtype=All"
    }

    },
    {
        img: CruiseDeal6,
        Destination:  "Europe" ,    //Azamara
        Offer : "Upto USD 2,500 Off + Upto USD 500 Onboard Credit ",
        Ship : "Valid till 31st July 2025 ",
         Brand : DealLogoAzamara,
                  link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=1043&destinations=15&durations=&destinationtype=All",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=1043&destinations=15&durations=&destinationtype=All"
    }

    },
    {
        img: CruiseDeal7,
        Destination:  "Europe" ,    //Silversea
        Offer : "Save Up to 40% ",
        Ship : "Valid till 31st July 2025 ",
         Brand : DealLogoSilver,
                  link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=8115&destinations=75&durations=&destinationtype=All",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=8115&destinations=75&durations=&destinationtype=All"
    }
       

    },
    {
        img: CruiseDeal8,
        Destination:  "Alaska" ,  //Silversea
        Offer : "Save Up to 40% ",
        Ship : "Valid till 31st July 2025 ",
         Brand : DealLogoSilver,
                  link :{
        USD :"https://booking.tirun.com/swift/cruise?siid=1035987&searchcruise=1&cruiseline=8115&destinations=1&durations=&destinationtype=All",
        INR : "https://booking.tirun.com/swift/cruise?siid=1113842&searchcruise=1&cruiseline=8115&destinations=1&durations=&destinationtype=All"
    }
       

    }
]

export default CruiseDealdata ;